"use client"

import { useCallback } from "react"
import { STORAGE_KEYS } from "../constants/sync-progress"

export const useLocalStorageCleanup = () => {
  const cleanupFlowData = useCallback(() => {
    const keysToRemove = [
      STORAGE_KEYS.HUBSPOT_CONNECTED,
      STORAGE_KEYS.MODIFY_SYNC_CONFIGURATION,
      STORAGE_KEYS.SALESFORCE_CONNECTED,
      STORAGE_KEYS.SYNC_CONFIGURATION,
      STORAGE_KEYS.FIELD_MAPPINGS,
      STORAGE_KEYS.CONNECTOR_FLOW_STEP,
      STORAGE_KEYS.SYNCING_STATUS,
      STORAGE_KEYS.SYNC_COMPLETED,
      STORAGE_KEYS.SELECTED_SYNC_OPTION,
      STORAGE_KEYS.SELECTED_CONNECTOR,
      STORAGE_KEYS.TARGET_OBJECT,
      STORAGE_KEYS.SOURCE_OBJECT,
    ]

    keysToRemove.forEach((key) => {
      try {
        localStorage.removeItem(key)
      } catch (error) {
        console.error(`Error removing localStorage key "${key}":`, error)
      }
    })
  }, [])

  const markFlowCompleted = useCallback(() => {
    try {
      localStorage.setItem(STORAGE_KEYS.CONNECTOR_FLOW_STEP, "completed")
      localStorage.setItem(STORAGE_KEYS.SYNC_COMPLETED, "true")
    } catch (error) {
      console.error("Error marking flow as completed:", error)
    }
  }, [])

  const getSyncingStatus = useCallback((): string => {
    try {
      const status = localStorage.getItem(STORAGE_KEYS.SYNCING_STATUS)
      if (status === "save") {
        return "Saved"
      }
      return status || "Started"
    } catch (error) {
      console.error("Error getting syncing status:", error)
      return "Started"
    }
  }, [])

  return {
    cleanupFlowData,
    markFlowCompleted,
    getSyncingStatus,
  }
}
